<template>
  <v-card class="ma-0 pa-0">
    <!-- Intestazione della tabella -->
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Lavoro Squadra </v-toolbar-title>
      <v-spacer></v-spacer>

      <!-- Bottone di salvataggio -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="setCommessaTempiSquadra"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Salva</span>
      </v-tooltip>
      <!-- Bottone di salvataggio -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickAggiungiOperatore" small v-bind="attrs" v-on="on">
            <v-icon color="primary"> mdi-plus </v-icon>
          </v-btn>
        </template>
        <span>Aggiungi Operatore</span>
      </v-tooltip>
      <v-spacer></v-spacer>

      <!-- Bottone di chiusura -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>

    <v-card-text>
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-data-table
              height="50vh"
              :headers="headers_squadra"
              :items="items_squadra"
            >
              <!-- Spazio dell'ora di inizio -->
              <template v-slot:[`item.start_stop`]="{ item }">
                <v-btn
                  @click="switchStartStop(item)"
                  :color="
                    item.ora_inizio == null ||
                    (item.ora_inizio != null && item.ora_fine != null)
                      ? 'success'
                      : 'error'
                  "
                  :disabled="item.was_clicked > 0"
                  tile
                >
                  <v-icon color="white">
                    {{
                      item.ora_inizio == null ||
                      (item.ora_inizio != null && item.ora_fine != null)
                        ? "mdi-play"
                        : "mdi-stop"
                    }}
                  </v-icon>
                </v-btn>
              </template>

              <!-- Spazio dell'ora di inizio -->
              <template v-slot:[`item.ora_inizio`]="{ item }">
                {{ formatData(item.ora_inizio) }}
              </template>

              <!-- Spazio dell'ora di inizio -->
              <template v-slot:[`item.ora_fine`]="{ item }">
                {{ formatData(item.ora_fine) }}
              </template>
              <template> </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-dialog v-model="aggiungi_operatore_visible" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Operatori Selezionabili
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="aggiungiOperatori" v-bind="attrs" v-on="on" small>
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Aggiungi</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="aggiungi_operatore_visible = false"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-data-table
          :headers="headers_squadra_selezionabile"
          :items="items_squadra_selezionabile"
        >
          <template v-slot:[`item.seleziona`]="{ item }">
            <v-btn
              @click="selezionaOperatore(item)"
              :color="
                item.selezionato == null ||
                item.selezionato == false ||
                item.selezionato == ''
                  ? 'success'
                  : 'error'
              "
              tile
            >
              <v-icon color="white">
                {{
                  item.selezionato == null ||
                  item.selezionato == false ||
                  item.selezionato == ""
                    ? "mdi-check"
                    : "mdi-close"
                }}
              </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>

      <!-- Overlay di caricamento -->
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <!-- Snackbar -->
      <SnackbarQV ref="SnackbarQVSelezione" />
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "LavoroSquadra",
  components: { SnackbarQV },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    work_order_sel: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      salvataggio_allowed: true,

      // Modal
      aggiungi_operatore_visible: false,
      overlay: false,

      // Array
      headers_squadra: [
        { text: "Nominativo", value: "nominativo", sortable: false },
        {
          text: "Start / Stop",
          value: "start_stop",
          sortable: false,
          width: "200px",
        },
        { text: "Ora Inizio", value: "ora_inizio", sortable: false },
        { text: "Ora Fine", value: "ora_fine", sortable: false },
      ],
      headers_squadra_selezionabile: [
        {
          text: "Seleziona",
          value: "seleziona",
          sortable: false,
          width: "200px",
        },
        { text: "Nominativo", value: "nominativo", sortable: false },
      ],
      items_squadra: new Array(),
      items_squadra_selezionabile: new Array(),
    };
  },
  computed: {},
  watch: {
    visible: {
      immediate: true,
      handler() {
        if (this.visible === true) {
          this.getCommessaTempiSquadra();
          this.salvataggio_allowed = true;
        }
      },
    },
  },
  methods: {
    aggiungiOperatori() {
      const arr_tmp = new Array();
      let chk_ricorrenza = false;

      // Aggiungo solo il personale selezionato che non ricorre già nella squadra.
      this.items_squadra_selezionabile.forEach((ss) => {
        if (
          ss.selezionato === true &&
          this.items_squadra.filter((e) => e.id_personale == ss.id_personale)
            .length == 0
        ) {
          const obj_tmp = {
            nominativo: ss.nominativo,
            id_personale: ss.id_personale,
            id_commessa_tempi_squadra: ss.id_commessa_tempi_squadra,
            id_commessa_dettaglio: this.work_order_sel.id_commessa_dettaglio,
            id_commessa: this.work_order_sel.id_commessa,
            ora_inizio: null,
            ora_fine: null,
            id_commessa_tempi: this.work_order_sel.id_commessa_tempi,
          };

          arr_tmp.push(obj_tmp);
        } else {
          // Se becco un elemento che ricorre già nella squadra, me lo annoto.
          if (
            this.items_squadra.filter(
              (e) => e.id_personale == ss.id_personale && ss.selezionato == true
            ).length > 0
          ) {
            chk_ricorrenza = true;
          }
        }
      });

      // Se volevo aggiungere un membro già aggiunto, stampo solo un avviso.
      if (chk_ricorrenza === true) {
        this.$refs.SnackbarQVSelezione.print(
          "orange",
          "Il personale selezionato è già incluso nella squadra."
        );
      } else {
        // Se era tutto ok, aggiungo i membri del team.
        arr_tmp.forEach((e) => {
          const obj_tmp = JSON.parse(JSON.stringify(e));
          obj_tmp.was_clicked = 0;
          this.items_squadra.push(obj_tmp);
        });

        this.aggiungi_operatore_visible = false;
      }
    },
    clickAggiungiOperatore() {
      this.items_squadra_selezionabile.forEach((e) => {
        e.selezionato = false;
      });

      this.aggiungi_operatore_visible = true;
    },
    clickChiudi() {
      this.$emit("click_chiudi");
      this.items_squadra = new Array();
      this.items_squadra_selezionabile = new Array();
    },
    formatData(arg) {
      if (arg == null || arg == "") {
        return "N/D";
      } else {
        let strRes = "";
        strRes += arg.substr(8, 2);
        strRes += "/";
        strRes += arg.substr(5, 2);
        strRes += "/";
        strRes += arg.substr(0, 4);
        strRes += " ";
        strRes += arg.substr(11, 8);
        return strRes;
      }
    },
    getCommessaTempiSquadra() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessatempisquadra",
          token: localStorage.user_token,
          id_commessa_dettaglio: this.work_order_sel.id_commessa_dettaglio,
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            // Resetto gli array di supporto
            this.items_squadra = new Array();
            this.items_squadra_selezionabile = new Array();
            res.data.squadra.forEach((e) => {
              if (e.id_commessa_tempi_squadra != -1) {
                const obj_tmp = JSON.parse(JSON.stringify(e));
                obj_tmp.was_clicked = 0;
                this.items_squadra.push(obj_tmp);
              } else {
                this.items_squadra_selezionabile.push(Object.assign({}, e));
              }
            });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          this.overlay = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    getOperatoriSquadra() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessatempisquadra",
          token: localStorage.user_token,
          id_commessa_dettaglio: this.work_order_sel.id_commessa_dettaglio,
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.items_squadra_selezionabile = res.data.squadra;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          this.overlay = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    selezionaOperatore(arg) {
      // Mi faccio un oggetto con il valore di selezione corretto.
      const obj_tmp = Object.assign({}, arg);
      obj_tmp.selezionato = arg.selezionato === true ? false : true;

      // Mi metto da parte l'indice selezionato.
      let index = -1;
      for (let i = 0; i < this.items_squadra_selezionabile.length; i++) {
        if (
          this.items_squadra_selezionabile[i].id_personale == arg.id_personale
        ) {
          index = i;
        }
      }

      this.$set(this.items_squadra_selezionabile, index, obj_tmp);
    },
    setCommessaTempiSquadra() {
      if (!this.salvataggio_allowed) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Impossibile salvare, ci sono incongruenze di data. Contattare Più Sviluppo."
        );

        return;
      }

      const arr_tmp = JSON.parse(JSON.stringify(this.items_squadra));
      // arr_tmp.forEach((e) => {
      //   e.ora_inizio =
      //     e.ora_inizio != null ? e.ora_inizio.replace(" ", "T") : null;
      //   e.ora_fine = e.ora_fine != null ? e.ora_fine.replace(" ", "T") : null;
      // });

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessatempisquadra",
          token: localStorage.user_token,
          squadra: arr_tmp,
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.$emit("salvato_lavoro");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          this.overlay = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    switchStartStop(arg) {
      /* Se l'id è a -1 e ho già segnato uno start e uno stop
       * non posso segnare, altrimenti segnerei uno start e perderei
       * una coppia di start e stop su una riga nuova. */
      if (
        arg.id_commessa_tempi_squadra == -1 &&
        arg.ora_inizio != null &&
        arg.ora_fine != null
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Ci sono già modifiche non salvate per questa riga. Per modificare ulteriormente, salvare i dati attuali e proseguire."
        );
        return;
      }

      /* Se l'id_commessa_tempi è diverso da quello attuale, o se
       * sto segnando uno start su una riga che era già piena, metto
       * id_commessa_tempi_squadra a -1 perché voglio creare una nuova
       * riga sul DB e aggiorno anche id_commessa_tempi perché potrebbe
       * essere necessario. */
      if (
        arg.id_commessa_tempi != this.work_order_sel.id_commessa_tempi ||
        (arg.ora_inizio != null && arg.ora_fine != null)
      ) {
        arg.id_commessa_tempi = this.work_order_sel.id_commessa_tempi;
        arg.id_commessa_tempi_squadra = -1;
      }

      /* Se non ho iniziato o ho iniziato e finito, faccio
       * in modo che ci sia un inizio e non una fine */
      if (
        arg.ora_inizio == null ||
        (arg.ora_inizio != null && arg.ora_fine != null)
      ) {
        arg.ora_inizio = new moment().format("YYYY-MM-DD HH:mm:ss");
        arg.ora_fine = null;
      } else {
        arg.ora_fine = new moment().format("YYYY-MM-DD HH:mm:ss");

        if (moment(arg.ora_fine).diff(moment(arg.ora_inizio), "days") > 1) {
          this.salvataggio_allowed = false;
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore nella definizione della data: contattare Più Sviluppo."
          );
        }
      }

      arg.was_clicked++;
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>